import React from "react";
import { Typography } from "../../design_system/StyledComponents/components/Typography.js";
import WallIcon from "../../assets/WallIcon.svg";
import DoorIcon from "../../assets/DoorIcon.svg";
import WindowIcon from "../../assets/WindowIcon.svg";
import slidingDoorIcon from "../../assets/slidingDoorIcon.svg";
import RailingIcon from "../../assets/RailingIcon.svg";
import "./ContextualMenu.css";
import { Html } from "@react-three/drei";
import { useDispatch, useSelector } from "react-redux";
import { setLockForLines, setTypeId } from "../../Actions/DrawingActions.js";
import { setHelpVideo, setSelectedLinesState, updateLineTypeId } from "../../Actions/ApplicationStateAction.js";
import split from "../../assets/split.png";
import mergeIcon from "../../assets/merge.png";
import Unlocked from "../../assets/Unlocked.png";
import Delete from "../../assets/Delete.png";
import DeleteAlt from "../../assets/Delete.svg";
import { setLineBreakState, setMergeState } from "../../features/drawing/drwingSlice.js";
import useModes from "../../hooks/useModes.js";
import { useDrawing } from "../../hooks/useDrawing.js";
import divide from "../../assets/WallOpening.png";
import { Close, CookieSharp } from "@mui/icons-material";
import { setShowSetScalePopup } from "../../Actions/ApplicationStateAction.js";

const ContextualMenu = () => {
  const dispatch = useDispatch();
  const { contextualMenuStatus, position, positionType, locked, typeId, showPropertiesPopup } = useSelector(
    (state) => state.Drawing
  );
  const {storeLines, selectionMode, selectedLines, tutorialActive, highlightMenu} = useSelector((state) => state.ApplicationState)
  const { lineBreak, merge } = useSelector((state) => state.drawing);
  const {toggleSelectionSplitMode, toggleSelectionMode} = useModes();
  const {deleteSelectedLines, handleMergeClick} = useDrawing();
  
  const handleWallClick = (e) => {
    e.stopPropagation();
    dispatch(updateLineTypeId(1));
    // dispatch(setTypeId(1));
    dispatch(setSelectedLinesState([]));
    dispatch(setShowSetScalePopup(false));
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "Wall");
  };
  const handleDoorClick = (e) => {
    e.stopPropagation();
    dispatch(updateLineTypeId(2));
    // dispatch(setTypeId(2));
    dispatch(setSelectedLinesState([]));
    dispatch(setShowSetScalePopup(false));
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "Door");
  };
  const handleWindowClick = (e) => {
    e.stopPropagation();
    dispatch(updateLineTypeId(3));
    // dispatch(setTypeId(3));
    dispatch(setSelectedLinesState([]));
    dispatch(setShowSetScalePopup(false));
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "Window"); 
  };
  const handleSlidingDoorClick = (e) => {
    e.stopPropagation();
    dispatch(updateLineTypeId(7));
    dispatch(setSelectedLinesState([]));
    dispatch(setShowSetScalePopup(false));
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "SlidingDoor"); 
  };
  const handleRailingClick = (e) => {
    e.stopPropagation();
    dispatch(updateLineTypeId(4));
    // dispatch(setTypeId(4));
    dispatch(setSelectedLinesState([]));
    dispatch(setShowSetScalePopup(false));
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "Railing");
  };

  const handleDivideClick = (e) => {
    e.stopPropagation()
    dispatch(updateLineTypeId(5));
    // dispatch(setTypeId(5));
    dispatch(setSelectedLinesState([]));
    dispatch(setShowSetScalePopup(false));
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "Opening");
  };

  const handleMerge = (e) => {
    e.stopPropagation()
    handleMergeClick();
    dispatch(setLineBreakState(false));
    dispatch(setShowSetScalePopup(false));
    if (!selectionMode) {
      toggleSelectionSplitMode();
    }
    dispatch(setMergeState(!merge));
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "Merge");
  };

  const handleSplitClick = (e) => {
    e.stopPropagation()
    dispatch(setMergeState(false));
    dispatch(setShowSetScalePopup(false));
    if (!lineBreak && selectionMode) {
      toggleSelectionSplitMode();
    } else if (lineBreak && !selectionMode) {
      toggleSelectionSplitMode();
    }
    dispatch(setLineBreakState(!lineBreak));
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "Split");
  };

  const handlDeleteClick = (e) => {
    dispatch(setShowSetScalePopup(false));
    e.stopPropagation()
    if (!selectionMode) {
      toggleSelectionSplitMode();
    } else {
      deleteSelectedLines();
    }
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "Delete");
  };

  const handleLockClick = (e) => {
    dispatch(setShowSetScalePopup(false));
    e.stopPropagation()
    dispatch(setLockForLines(!locked));
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "Lock");
  };

  const handleStopDrawing = (e) => {
    dispatch(setShowSetScalePopup(false));

    e.stopPropagation()
    toggleSelectionMode();
    if(tutorialActive){
      dispatch(setHelpVideo(true, "finishTutorial"))
    }
    window.GAEvent("DrawTool", "ContextualMenu", "ButtonClicked", "StopDrawing");
  };

  let menuSelectedLine = null
  menuSelectedLine = storeLines.find((line) => line.id === selectedLines[0]);
  if (menuSelectedLine === undefined || menuSelectedLine === null){
    menuSelectedLine = storeLines[storeLines.length - 1]
  }

  return (
    contextualMenuStatus && (
      <Html 
      position={position} 
      className="contextual-menu-component"
      occlude={false}           // Prevents occlusion calculations
      transform={false}         // Keeps HTML in screen space
      sprite={true}             // Makes it always face the camera
      distanceFactor={1}       // Controls scaling with distance
      zIndexRange={[100, 0]} 
      >
          {(positionType === "neutral" && !tutorialActive) || (tutorialActive && highlightMenu==="stopDrawing" )&&
          <div className="btn-container" style={{justifyContent:"flex-start", width:"100%", marginBottom: "8px"}}>
            <div className='escape-helper-right' onClick={handleStopDrawing}>
              <Close />
              <Typography modifiers={["subtitle3", "bold"]}>Stop drawing</Typography>
            </div>
          </div>
          }
        <div className="contextual-menu-element-container">

        <div className={positionType}/>
        <div>
            <Typography modifiers={["body"]}>Change to</Typography>
        </div>
        
        <div className="contextual-menu-element-container-icons">
        {
          menuSelectedLine?.type!="wall" &&
          <div className={"contextual-menu-element" + (highlightMenu !== "wall" && tutorialActive? " blurred": "")} onClick={handleWallClick}>
            <img src={WallIcon} alt="" />
            <Typography className="contextual-menu-text">Wall</Typography>
          </div>
        }
        {
          menuSelectedLine?.type!="door" &&
          <div className={"contextual-menu-element" + (highlightMenu !== "door" && tutorialActive? " blurred": "")} onClick={handleDoorClick}>
            <img src={DoorIcon} alt="" />
            <Typography className="contextual-menu-text">Door</Typography>
          </div>
        }
        {
          menuSelectedLine?.type!="window" &&
          <div className={"contextual-menu-element" + (highlightMenu !== "window" && tutorialActive? " blurred": "")} onClick={handleWindowClick}>
            <img src={WindowIcon} alt="" />
            <Typography className="contextual-menu-text">Window</Typography>
          </div>
        }

        {
          menuSelectedLine?.type!="sliding_window" && !tutorialActive &&
          <div className={"contextual-menu-element" + (highlightMenu !== "window" && tutorialActive? " blurred": "")} onClick={handleSlidingDoorClick}>
            <img src={slidingDoorIcon} alt="" />
            <Typography className="contextual-menu-text">Glidor</Typography>
          </div>
        }

        
        {
          menuSelectedLine?.type!="railing" && !tutorialActive && <div className="contextual-menu-element" onClick={handleRailingClick}>
            <img src={RailingIcon} alt="" />
            <Typography className="contextual-menu-text">Railing</Typography>
          </div>
        }

        {
          menuSelectedLine?.type!="imaginary" && !tutorialActive && <div className="contextual-menu-element" onClick={handleDivideClick}>
              <img style={{height:"34px", width:"34px",borderRadius:"50%"}} src={divide} alt="" />
              <Typography className="contextual-menu-text">Opening</Typography>
          </div>
        }
        </div>
        </div>

          {( positionType !== "neutral" & showPropertiesPopup) ? 
            <div className="btn-container" style={{justifyContent:"flex-start", width:"100%", marginLeft: "18px"}}>
            {typeId===1 ?
            <div
              onClick={handleSplitClick}
              className="btn"
              style={{ border: lineBreak ? "2px solid cornflowerblue" : "" }}
            >
              <img src={split} alt="" />
              <Typography className="contextual-btn-text">Split</Typography>
            </div>:null}
            {typeId === 1?
            <div
              onClick={handleMerge}
              className="btn"
              style={{ border: merge ? "2px solid cornflowerblue" : "" }}
            >
              <img src={mergeIcon} alt="" />
              <Typography className="contextual-btn-text">Merge</Typography>
            </div>: null}
            {lineBreak || merge ? null : (
              <div
                className="btn"
                style={{ border: locked ? "2px solid cornflowerblue" : "" }}
                onClick={handleLockClick}
              >
                <img src={Unlocked} alt="" />
                <Typography className="contextual-btn-text">Lock</Typography>
              </div>
            )}
            {lineBreak || merge ? null : (
              <div className="btn" onClick={handlDeleteClick} style={{backgroundColor:"#FBEAE9", color:"#F5453E"}}>
                <img src={DeleteAlt} alt="" />
                <Typography style={{color:"#F5453E"}} className="contextual-btn-text">
                  Delete
                </Typography>
              </div>
            )}
          </div>
          : null
          }
      </Html>
    )
  );
};

export default ContextualMenu;
